import { ArrowRight, Bank, DevicesMobile, ShieldSafety } from '@sravni/react-icons';

import EsiaIcon from './assets/esia.svg';

export const FinPlatformItems = [
  {
    icon: <ShieldSafety />,
    color: 'green',
    title: 'Защита данных',
    text: 'Регулярный аудит информационной безопасности. Все данные передаются в зашифрованном виде. Включены в реестр операторов персональных данных Роскомнадзора.',
  },
  {
    icon: <EsiaIcon />,
    color: 'dark',
    title: 'Безопасно на высшем уровне',
    text: 'Интеграция с государственной платформой Госуслуг.',
  },
  {
    icon: <DevicesMobile />,
    color: 'violet',
    title: 'Оформление онлайн',
    text: 'Оформляйте кредит или займ напрямую через финансовую платформу Сравни.ру — без посещения сторонних сайтов.',
  },
  {
    icon: <Bank />,
    color: 'blue',
    title: 'Банки в реестре ЦБ РФ',
    text: 'Все банки из списка внесены в Реестр кредитных организаций ЦБ РФ.',
    link: 'https://www.cbr.ru/banking_sector/credit/FullCoList/',
    linkLabel: 'Проверьте по ссылке',
    linkIcon: <ArrowRight />,
  },
];

export const FIN_ORG_URL = 'https://www.cbr.ru/finorg/foinfo/?ogrn=1207700502107';
